import clsx from 'clsx'
import React from 'react'

import { ITenantUserStatus } from '../../services/types'
import { EmunTeamStatus } from '../../types/tenant/team.types'

export const PillStatus = ({ status }: { status: string }) => {
    return (
        <span
            className={clsx('pill capitalize', {
                'pill-success':
                    status === EmunTeamStatus.ACTIVE ||
                    ITenantUserStatus.ACTIVE,
                'pill-busy': status === EmunTeamStatus.BUZY,
                'pill-on-leave':
                    status === ITenantUserStatus.OFFLINE ||
                    status === EmunTeamStatus.INACTIVE,
            })}
        >
            {status}
        </span>
    )
}
